// components/business/message-container/components/box/chat-msg-box/chat-msg-box.js
Component({
    /**
     * 组件的属性列表
     */
    properties: {
        msg: {
            type: Object,
            value: {},
            observer: function (msg) {
                let feature = msg.feature || {};
                let msgContent = msg.content || {};
                let robotMsg = {};
                if (typeof msg.feature == "string") {
                    feature = JSON.parse(msg.feature || "{}");
                }
                if (typeof msgContent == "string") {
                    msgContent = JSON.parse(msgContent || "{}");
                }
                if (msgContent&&msgContent.runningVertex) {
                    robotMsg = msgContent.runningVertex
                }
                const data = { feature,msgContent,robotMsg };
                if (msg.subType === 3) {
                    data.duration = (feature["du"] || 0) * 1000;
                }

                const { img, title, subTitle, content, autoClick, redirectUrl } = robotMsg?.cardAttrDTO || {};
                const cardInfo = {
                    title,
                    subTitle,
                    text: '',
                    subText: content,
                    pics: [img],
                    auto: autoClick,
                    plf: [redirectUrl?.H5 ? 'h5' : null],
                    h5: redirectUrl?.H5,
                    expireDate: '',
                };
                data.cardInfo = cardInfo
                this.setData(data);
            }
        },
        // 展示所有图片消息集合
        imgUrls: {
            type: Array,
            value: [],
        },
    },

    /**
     * 组件的初始数据
     */
    data: {
        duration: 0,
        feature: {},
        msgContent:{},
        robotMsg:{},
        cardInfo:{},
    },

    /**
     * 组件的方法列表
     */
    methods: {},
});
